import { AddDoorComponentonWall, calculateLegsCount, commonFunctionForComponent, commonFunctionForColor, commonFunctionForExtraBows, updateBreezewayFrameAndStorages } from "../common/common.helper";
import * as cuBuilding from "../../redux/reducers/building_pricing/pricingReducer";
import * as utils from "../../redux/reducers/utils";
import { defaultInsulationValues } from "../../Constants/constant";
import { const_var, params } from "../../redux/reducers/reducer";
import { updateCenterBuildingInsulation } from "../insulation_pricing/insulationPricing.helper";
import { setHorizontalAndVerticalWalls } from "../building_pricing/wall_pricing/wallPricing.helper";
import { checkRoofPitch } from "../building/building_config/building.helper";
import { updateBracingSelection } from "../building_component/buildingComponent.helper";
import { checkReinforcedLeg } from "../building_component/legs_condition.helper";
import { updateTrussId } from "../building_component/truss/truss.helper";
import { updateOverhangOnLeanUpdate } from "../extra_options_pricing/overhangPricing";

const setPricingDataForLeanto = (state, response, type, flag, reducerFns = {}) => {
	const { dynamicWallOptions, makeDimensionUpdateBack, makeDimensionUpdateFront, makeDimensionUpdateLeft, makeDimensionUpdateRight } = reducerFns;
	let a_p_d_a = const_var.isLTBuilding ? JSON.parse(JSON.stringify(const_var.holdPricingResponse ?? "")) : const_var.a_p_d_a;
	let dataNew = "";
	if (response.data != undefined) {
		const_var.roof_style_Barn = response.data.building_structure;
		if (response.success == true) {
			if (response.data.central_side != undefined && response.data.central_side.length > 0) {
				setHorizontalAndVerticalWalls(response.data.central_side[0], response.data.panel[0]);
			}
			if (response.data.central_side == undefined && response.data.central_side_full_length != undefined && response.data.central_side_full_length.length > 0) {
				setHorizontalAndVerticalWalls(response.data.central_side_full_length[0], response.data.panel[0]);
			}
		}
	}

	if (const_var.isCheckGroundCertificate != undefined && const_var.isCheckGroundCertificate == true && (params.m_s_n == 11 || params.m_s_n == 54 || params.m_s_n == 147 || params.m_s_n == 160)) {
		utils.surfaceCertificateApplied(state);
	}
	if (type == "addLeftLean") {
		const_var.makeCertificateArrayLeft = {};
		const_var.leanGetDataLeft = response.success == true ? JSON.parse(JSON.stringify(response.data)) : const_var.leanGetDataLeft;

		if (const_var.selectedLeanType == "left") {
			const_var.a_p_d_a = JSON.parse(JSON.stringify(const_var.leanGetDataLeft));
		}

		updateTrussId("left", state, const_var.leanGetDataLeft);
		updateOverhangOnLeanUpdate("left", state, const_var.leanGetDataLeft);

		let buildingStructure = const_var.leanGetDataLeft?.building_structure?.[0];
		if (buildingStructure && !(parseFloat(params.lean_p_h) <= parseFloat(buildingStructure.max_height) && parseFloat(params.lean_p_h) >= parseFloat(buildingStructure.min_height))) {
			params.lean_p_h = const_var.leanGetDataLeft.building_structure[0].min_height;
		}

		if (
			params.p_c_i == true &&
			response.success == true &&
			response.data.insulation &&
			const_var.leanGetDataLeft &&
			const_var.insulationArrayForLeantoLeft.insulation_wall &&
			Object.keys(const_var.insulationArrayForLeantoLeft.insulation_wall).length > 0
		) {
			let isInsulationAdded = Object.keys(const_var.insulationArrayForLeantoLeft.insulation_wall).find((key) => const_var.insulationArrayForLeantoLeft.insulation_wall[key] == true);
			params.p_c_i = isInsulationAdded != undefined ? params.p_c_i : false;
			params.p_f_i = false;
		}

		if (const_var.isLTBuilding) {
		updateBracingSelection("left");
		}

		updateCenterBuildingInsulation(const_var.leanGetDataLeft.central_insulation);

		if (
			params.p_i_o != 0 &&
			const_var.leanGetDataLeft?.central_insulation != undefined &&
			const_var.isInsulaltionForOldQuotes == false &&
			const_var.crmSetting.is_Edit == true &&
			const_var.leanGetDataLeft.central_insulation.filter((obj) => obj.insulation_id == params.p_i_o).length == 0
		) {
			params.p_i_o = const_var.leanGetDataLeft.central_insulation[0].insulation_id; //0
			params.selectedInsulationId = const_var.leanGetDataLeft.central_insulation[0].insulation_id;

			params.insulation.center.isCheked = false;
			params.insulation.center.insulationId = 0;
			params.insulation.center.roofOnly = false;
			params.insulation.center.fullBuilding = false;
			params.insulation.center.custom = false;
			params.insulation.center.showInsulationOptions = false;
			params.insulation.center.isDisableFullInsulation = false;
			params.l_t_p = JSON.parse(JSON.stringify(defaultInsulationValues));
		}

		cuBuilding.makeInsulationArrayForLeanto();
		cuBuilding.makeCertificateArrayLeft("left");
		if (response.success == true && const_var.leanGetDataLeft.central_side != undefined && const_var.leanGetDataLeft.central_side.length > 0)
			setHorizontalAndVerticalWalls(response.data.central_side[0], response.data.panel[0]);

		if (const_var.leanGetDataLeft.building_structure != undefined && const_var.leanGetDataLeft.building_structure.length > 0) {
			if (Object.keys(const_var.leanGetDataLeft.building_structure[0].conditions).length !== 0) {
				const_var.ConditionArrForLean["left"] = const_var.leanGetDataLeft.building_structure[0].conditions["Leg_Height_condition"];
				checkReinforcedLeg(const_var.ConditionArrForLean["left"]);
			}
		}
		cuBuilding.CheckLeanLegsByResponse(state, type);
		if (const_var.leanGetDataLeft.central_side != undefined && const_var.leanGetDataLeft.central_side.length > 0) {
			const_var.a_p_d_a.side = const_var.leanGetDataLeft.central_side;
		}
		if (const_var.leanGetDataLeft.central_side_full_length != undefined && const_var.leanGetDataLeft.central_side_full_length.length > 0) {
			const_var.a_p_d_a.full_length_side = const_var.leanGetDataLeft.central_side_full_length;
		}
		if (const_var.leanGetDataLeft.central_end != undefined && const_var.leanGetDataLeft.central_end.length > 0) {
			const_var.a_p_d_a.end = const_var.leanGetDataLeft.central_end;
		}
		if (const_var.leanGetDataLeft.central_utility_side != undefined && const_var.leanGetDataLeft.central_utility_side.length > 0) {
			const_var.a_p_d_a.utility_side = const_var.leanGetDataLeft.central_utility_side;
		}
		if (const_var.leanGetDataLeft.end_combo_v3 != undefined && const_var.leanGetDataLeft.end_combo_v3.length > 0) {
			const_var.a_p_d_a.end_combo_v3 = const_var.leanGetDataLeft.end_combo_v3;
		}
		if (const_var.leanGetDataLeft.side_combo_v3 != undefined && const_var.leanGetDataLeft.side_combo_v3.length > 0) {
			const_var.a_p_d_a.side_combo_v3 = const_var.leanGetDataLeft.side_combo_v3;
		}
		if (const_var.leanGetDataLeft.central_trusses != undefined && const_var.leanGetDataLeft.central_trusses.length > 0) {
			const_var.a_p_d_a.trusses = const_var.leanGetDataLeft.central_trusses;
		}
		utils.updateCenterBuildingPricesOnLeanAPICalls(state, "leanGetDataLeft", "left");
		if (const_var.crmSetting.is_Edit != true) {
			if (type != undefined && type == "addLeftLean" && state.params.add_left_lean != true) {
				if (params.p_i_o != 0 && params.p_f_i) updateCenterBuildingInsulation(const_var.a_p_d_a.old_insulation);

				if (state.params.add_front_lean || state.params.add_back_lean || state.params.add_right_lean) {
					if (params.p_i_o != 0 && params.p_f_i) updateCenterBuildingInsulation(const_var.leanGetDataLeft.central_insulation);
				}
				const_var.UpdatedPriceData.insulation_price = undefined;
				const_var.UpdatedPriceData.insulation_price_changed = true;
			} else {
				const_var.UpdatedPriceData.front_wall_price_changed = true;
				const_var.UpdatedPriceData.back_wall_price_changed = true;
			}
			const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
			const_var.UpdatedPriceData.height_price_changed = true;
			const_var.UpdatedPriceData.certificate_price_changed = true;
			const_var.UpdatedPriceData.wainscot_price_changed = true;

			const_var.UpdatedPriceData.roof_color_price_changed = true;
			const_var.UpdatedPriceData.wall_color_price_changed = true;
			const_var.UpdatedPriceData.trim_color_price_changed = true;
			const_var.UpdatedPriceData.left_lean_roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.leftLean_truss_price_changed = true;
			if (const_var.a_p_d_a.side[0]?.lift_type != undefined && const_var.a_p_d_a.side[0]?.lift_type != "") {
				const_var.UpdatedPriceData.lifttype_price_changed = true;
				params.lift_type = true;
			}
		} else {
			if (type != undefined && type == "addLeftLean" && state.params.add_left_lean != true) {
				if (params.p_i_o != 0 && params.p_f_i) updateCenterBuildingInsulation(const_var.a_p_d_a.old_insulation);

				if (state.params.add_front_lean || state.params.add_back_lean || state.params.add_right_lean) {
					if (params.p_i_o != 0 && params.p_f_i) updateCenterBuildingInsulation(const_var.leanGetDataLeft.central_insulation);
				}
				const_var.UpdatedPriceData.insulation_price = undefined;
				const_var.UpdatedPriceData.insulation_price_changed = true;
			}
		}
		if (const_var.a_p_d_a.connection_fees != undefined && const_var.a_p_d_a.connection_fees.length == 0) {
			const_var.a_p_d_a.connection_fees = const_var.leanGetDataLeft.connection_fees;
		}

		if (type == "addLeftLean" && const_var.isLTBuilding) {
			if (const_var.leanGetDataLeft?.side_cross_bracing == undefined || const_var.leanGetDataLeft?.side_cross_bracing?.length == 0) {
				params.added_building_bracing.p_s_c_b_l = false;
				const_var.selectedBracingForAddedBuilding.left_lean_side = "";
			}
			if (const_var.leanGetDataLeft?.side_cross_bracing?.length == 1 && const_var.leanGetDataLeft?.side_cross_bracing[0].sheet_name == undefined) {
				const_var.leanGetDataLeft.side_cross_bracing[0]["sheet_name"] = "diagonal_braces";
				const_var.leanGetDataLeft.side_cross_bracing[0]["sheet_label"] = "Diagonal Braces";
			}
			if (const_var.leanGetDataLeft?.side_cross_bracing?.length > 1) {
				let isNoneExsist = const_var.leanGetDataLeft.side_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
				if (isNoneExsist == undefined) {
					const_var.leanGetDataLeft.side_cross_bracing.push({
						map_id: const_var.leanGetDataLeft.side_cross_bracing[0].map_id,
						sheet_name: "none",
						sheet_label: "None",
						is_default: "yes",
						height: const_var.leanGetDataLeft.side_cross_bracing[0].height,
						length: const_var.leanGetDataLeft.side_cross_bracing[0].length,
						cost: 0
					});
				}
				if (const_var.crmSetting.is_Edit != true) {
					let defaultSelected = const_var.leanGetDataLeft.side_cross_bracing.find((obj) => obj.is_default == "included" /* 'yes' */);
					let isBracingExist = const_var.leanGetDataLeft.side_cross_bracing?.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.left_lean_side);
					if (defaultSelected != undefined || isBracingExist) {
						const_var.selectedBracingForAddedBuilding.left_lean_side = isBracingExist ? isBracingExist.sheet_name : defaultSelected.sheet_name;
						params.added_building_bracing.p_s_c_b_l = const_var.selectedBracingForAddedBuilding.left_lean_side == "none" ? false : true;
					} else {
						params.added_building_bracing.p_s_c_b_l = false;
						const_var.selectedBracingForAddedBuilding.left_lean_side = "none";
					}
				} else {
					if (const_var.selectedBracingForAddedBuilding.left_lean_side == "") {
						params.added_building_bracing.p_s_c_b_l = false;
						const_var.selectedBracingForAddedBuilding.left_lean_side = "none";
					}
				}
			}
			if (const_var.leanGetDataLeft?.side_cross_bracing?.length == 1) {
				if (const_var.leanGetDataLeft?.side_cross_bracing[0].is_default != "included") {
					let isNoneExsist = const_var.leanGetDataLeft.side_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
					if (isNoneExsist == undefined) {
						const_var.leanGetDataLeft.side_cross_bracing.push({
							map_id: const_var.leanGetDataLeft.side_cross_bracing[0].map_id,
							sheet_name: "none",
							sheet_label: "None",
							is_default: "yes",
							height: const_var.leanGetDataLeft.side_cross_bracing[0].height,
							length: const_var.leanGetDataLeft.side_cross_bracing[0].length,
							cost: 0
						});
					}
				}

				let isBracingExsist =
					const_var.selectedBracingForAddedBuilding.left_lean_side != "" && const_var.selectedBracingForAddedBuilding.left_lean_side != "none"
						? const_var.leanGetDataLeft.side_cross_bracing.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.left_lean_side)
						: undefined;
				if (isBracingExsist == undefined) {
					if (const_var.leanGetDataLeft?.side_cross_bracing[0].is_default == "included") {
						const_var.selectedBracingForAddedBuilding.left_lean_side = const_var.leanGetDataLeft?.side_cross_bracing[0].sheet_name;
						params.added_building_bracing.p_s_c_b_l = true;
					} else {
						params.added_building_bracing.p_s_c_b_l = false;
						const_var.selectedBracingForAddedBuilding.left_lean_side = "none";
					}
				}
			}

			if (const_var.leanGetDataLeft?.end_cross_bracing == undefined || const_var.leanGetDataLeft?.end_cross_bracing?.length == 0) {
				params.added_building_bracing.p_e_c_b_l = false;
				const_var.selectedBracingForAddedBuilding.left_lean_end = "";
			}
			if (const_var.leanGetDataLeft?.end_cross_bracing?.length == 1 && const_var.leanGetDataLeft?.end_cross_bracing[0].sheet_name == undefined) {
				const_var.leanGetDataLeft.end_cross_bracing[0]["sheet_name"] = "diagonal_braces";
				const_var.leanGetDataLeft.end_cross_bracing[0]["sheet_label"] = "Diagonal Braces";
			}

			if (const_var.leanGetDataLeft?.end_cross_bracing?.length > 1) {
				let isNoneExsist = const_var.leanGetDataLeft.end_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
				if (isNoneExsist == undefined) {
					const_var.leanGetDataLeft.end_cross_bracing.push({
						map_id: const_var.leanGetDataLeft.end_cross_bracing[0].map_id,
						sheet_name: "none",
						sheet_label: "None",
						is_default: "yes",
						height: const_var.leanGetDataLeft.end_cross_bracing[0].height,
						length: const_var.leanGetDataLeft.end_cross_bracing[0].length,
						cost: 0
					});
				}
				if (const_var.crmSetting.is_Edit != true) {
					let defaultSelected = const_var.leanGetDataLeft.end_cross_bracing.find((obj) => obj.is_default == "included" /* 'yes' */);
					let isBracingExist = const_var.leanGetDataLeft.end_cross_bracing?.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.left_lean_end);
					if (defaultSelected != undefined || isBracingExist) {
						const_var.selectedBracingForAddedBuilding.left_lean_end = isBracingExist ? isBracingExist.sheet_name : defaultSelected.sheet_name;
						params.added_building_bracing.p_e_c_b_l = const_var.selectedBracingForAddedBuilding.left_lean_end == "none" ? false : true;
					} else {
						params.added_building_bracing.p_e_c_b_l = false;
						const_var.selectedBracingForAddedBuilding.left_lean_end = "none";
					}
				} else {
					if (const_var.selectedBracingForAddedBuilding.left_lean_end == "") {
						params.added_building_bracing.p_e_c_b_l = false;
						const_var.selectedBracingForAddedBuilding.left_lean_end = "none";
					}
				}
			}

			if (const_var.leanGetDataLeft?.end_cross_bracing?.length == 1) {
				if (const_var.leanGetDataLeft?.end_cross_bracing[0].is_default != "included") {
					let isNoneExsist = const_var.leanGetDataLeft.end_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
					if (isNoneExsist == undefined) {
						const_var.leanGetDataLeft.end_cross_bracing.push({
							map_id: const_var.leanGetDataLeft.end_cross_bracing[0].map_id,
							sheet_name: "none",
							sheet_label: "None",
							is_default: "yes",
							height: const_var.leanGetDataLeft.end_cross_bracing[0].height,
							length: const_var.leanGetDataLeft.end_cross_bracing[0].length,
							cost: 0
						});
					}
				}

				let isBracingExsist =
					const_var.selectedBracingForAddedBuilding.left_lean_end != "" && const_var.selectedBracingForAddedBuilding.left_lean_end != "none"
						? const_var.leanGetDataLeft.end_cross_bracing.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.left_lean_end)
						: undefined;
				if (isBracingExsist == undefined) {
					if (const_var.leanGetDataLeft?.end_cross_bracing[0].is_default == "included") {
						const_var.selectedBracingForAddedBuilding.left_lean_end = const_var.leanGetDataLeft?.end_cross_bracing[0].sheet_name;
						params.added_building_bracing.p_e_c_b_l = true;
					} else {
						params.added_building_bracing.p_e_c_b_l = false;
						const_var.selectedBracingForAddedBuilding.left_lean_end = "none";
					}
				}
			}
		}
		dataNew = const_var.leanGetDataLeft;
		let filterRoofPitchData = "";
		if (params.p_r_s == 1 && params.m_s_n == 13) {
			state.const_var.BuildingLRoofPitch = [];

			filterRoofPitchData = dataNew.roof_pitch != undefined ? dataNew.roof_pitch.filter((data) => params.m_s_n == 13 && params.p_r_s == 1 && data.roof_pitch.split("/")[0] <= 3) : "";
			if (filterRoofPitchData != "" && filterRoofPitchData.length > 0) {
				dataNew.roof_pitch = JSON.parse(JSON.stringify(filterRoofPitchData));
				if (filterRoofPitchData.filter((data) => data.roof_pitch.split("/")[0] == params.b_l_t_r_p).length == 0) {
					let chkData = filterRoofPitchData.filter((data) => data.is_default == "yes");
					if (chkData.length > 0) {
						params.isDefault_l_t_r_p = params.b_l_t_r_p = chkData[0].roof_pitch.split("/")[0];
					} else {
						params.isDefault_l_t_r_p = params.b_l_t_r_p = filterRoofPitchData[0].roof_pitch.split("/")[0];
						cuBuilding.BuildingUpdate(true, "");
					}
				}
			}
		}
		let b_l_t_r_p_old = state.params.b_l_t_r_p;
		state.params.b_l_t_r_p = state.params.b_l_t_r_p;
		if (dataNew.roof_pitch != undefined && dataNew.roof_pitch.length > 0) {
			state.const_var.b_r_p_l_to_a = [];
			if (!utils.hasGableLeanto("left")) {
				if (state.const_var.BuildingLRoofPitch != undefined && Object.keys(state.const_var.BuildingLRoofPitch).length > 0) {
					Object.keys(state.const_var.BuildingLRoofPitch).map((roofP, idx) => {
						let isRoofPitchExsist = dataNew.roof_pitch.find((obj) => obj.roof_pitch == roofP);
						if (isRoofPitchExsist == undefined) {
							delete state.const_var.BuildingLRoofPitch[roofP];
						}
					});
				}
			}
			let isRoofPitchExsist = false;
			if (params.b_l_t_r_p && dataNew.roof_pitch.length > 0) {
				isRoofPitchExsist = dataNew.roof_pitch.find((obj) => obj.roof_pitch && obj.roof_pitch.split("/")[0] == params.b_l_t_r_p);
				isRoofPitchExsist = isRoofPitchExsist != undefined ? true : false;
				if (params.leanStyle.left == "gable") {
					checkRoofPitch(b_l_t_r_p_old, "left", dataNew);
				}
			}
			for (var i = 0; i <= dataNew.roof_pitch.length - 1; i++) {
				state.const_var.b_r_p_l_to_a[dataNew.roof_pitch[i].roof_pitch.split("/")[0]] = dataNew.roof_pitch[i];
				if (!utils.hasGableLeanto("left")) {
					state.const_var.BuildingLRoofPitch[dataNew.roof_pitch[i].roof_pitch] = dataNew.roof_pitch[i].roof_pitch.split("/")[0];
					state.const_var.leanto_roof_pitch_obj[dataNew.roof_pitch[i].roof_pitch] = dataNew.roof_pitch[i];
				}
				if (!isRoofPitchExsist && dataNew.roof_pitch[i].is_default == "yes" && const_var.checkforLeanto == true) {
					let buildingName = const_var.defaultBuildingArr[const_var.BuldingIDforReset] && const_var.defaultBuildingArr[const_var.BuldingIDforReset]?.image_name?.split(".")?.includes("Straight_Roof_Barns");

					let checkType =
						params.m_s_n == 3 &&
						buildingName &&
						((const_var.editAPIDataByResponse.data?.main_created_at >= "2024-07-01" && (const_var.crmSetting.is_Edit == true || const_var.isKLinkEnable == true)) ||
							const_var.loginSession == false ||
							const_var.loginSession == true)
							? true
							: false;
					params.isDefault_l_t_r_p = params.b_l_t_r_p = dataNew.roof_pitch[i].roof_pitch.split("/")[0];
					if (checkType == true) {
						params.b_l_t_r_p = "3";
					}
					if (params.leanStyle.left == "gable") {
						checkRoofPitch(b_l_t_r_p_old, "left", dataNew);
					}
					cuBuilding.UpdateLeftLean();
				}
			}
		}
		if (const_var.crmSetting.is_Edit == false && const_var.defaultBuildingArr[state.defaultBuilding] != undefined) {
			if (
				const_var.checkforLeanto == true &&
				const_var.defaultBuildingArr[state.defaultBuilding].leanto_data != undefined &&
				Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"]).length > 0
			) {
				let isRoofPitchExsist = dataNew.roof_pitch.find((obj) => obj.roof_pitch == const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].roof_pitch);
				if (isRoofPitchExsist != undefined) {
					params.isDefault_l_t_r_p = params.b_l_t_r_p = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].roof_pitch.split("/")[0];
					state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].roof_pitch] =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].roof_pitch.split("/")[0];
				}

				cuBuilding.UpdateLeftLean();
			} else {
				if (
					const_var.checkforLeanto == true &&
					const_var.defaultBuildingArr[state.defaultBuilding].leanto_data != undefined &&
					Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"]).length == 0 &&
					(const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch != undefined || const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch != null)
				) {
					params.isDefault_l_t_r_p = params.b_l_t_r_p = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
					state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch] = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
					cuBuilding.UpdateLeftLean();
				}
			}
		}

		if (const_var.checkforLeanto == true) {
			const_var.UpdatedPriceData.height_price_changed = true;
			if (params.p_i_o != 0) {
				const_var.UpdatedPriceData.roof_style_price_changed = true;
			}
			const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;

			const_var.UpdatedPriceData.bothLeanto = true;
			const_var.UpdatedPriceData.connection_fee_end_changed = true;
			const_var.UpdatedPriceData.connection_fee_side_changed = true;
			const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
			const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
			const_var.UpdatedPriceData.common_length_changed = true;
			const_var.UpdatedPriceData.left_wall_price_changed = true;
			const_var.UpdatedPriceData.common_left_lean_length_changed = true;
			const_var.UpdatedPriceData.common_right_lean_length_changed = true;
			const_var.UpdatedPriceData.common_front_lean_length_changed = true;
			const_var.UpdatedPriceData.common_back_lean_length_changed = true;
			const_var.UpdatedPriceData.common_left_lean_width_changed = true;
			const_var.UpdatedPriceData.common_right_lean_width_changed = true;
			const_var.UpdatedPriceData.common_front_lean_width_changed = true;
			const_var.UpdatedPriceData.common_back_lean_width_changed = true;
		}

		utils.checkColoredScrewsForLeanto("left", const_var.leanGetDataLeft);
		makeDimensionUpdateLeft(state);

		cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
		const_var.checkforLeanto = false;
	} else if (type == "addFrontLean") {
		const_var.makeCertificateArrayFront = {};
		const_var.leanGetDataFront = response.success == true ? JSON.parse(JSON.stringify(response.data)) : const_var.leanGetDataFront;

		if (const_var.selectedLeanType == "front") {
			const_var.a_p_d_a = JSON.parse(JSON.stringify(const_var.leanGetDataFront));
		}

		updateTrussId("front", state, const_var.leanGetDataFront);
		updateOverhangOnLeanUpdate("front", state, const_var.leanGetDataFront);

		let buildingStructure = const_var.leanGetDataFront?.building_structure?.[0];
		if (buildingStructure && !(parseFloat(params.leanF_p_h) <= parseFloat(buildingStructure.max_height) && parseFloat(params.leanF_p_h) >= parseFloat(buildingStructure.min_height))) {
			params.leanF_p_h = const_var.leanGetDataFront.building_structure[0].min_height;
		}

		if (
			params.p_c_i == true &&
			response.success == true &&
			response.data.insulation &&
			const_var.leanGetDataFront &&
			const_var.insulationArrayForLeantoFront.insulation_wall &&
			Object.keys(const_var.insulationArrayForLeantoFront.insulation_wall).length > 0
		) {
			let isInsulationAdded = Object.keys(const_var.insulationArrayForLeantoFront.insulation_wall).find((key) => const_var.insulationArrayForLeantoFront.insulation_wall[key] == true);
			params.p_c_i = isInsulationAdded != undefined ? params.p_c_i : false;
			params.p_f_i = false;
		}

		if (const_var.isLTBuilding) {
			updateBracingSelection("front");
		}

		updateCenterBuildingInsulation(const_var.leanGetDataFront.central_insulation);
		if (
			params.p_i_o != 0 &&
			const_var.leanGetDataFront?.central_insulation != undefined &&
			const_var.isInsulaltionForOldQuotes == false &&
			const_var.crmSetting.is_Edit == true &&
			const_var.leanGetDataFront.central_insulation.filter((obj) => obj.insulation_id == params.p_i_o).length == 0
		) {
			params.p_i_o = const_var.leanGetDataFront.central_insulation[0].insulation_id; //0
			params.selectedInsulationId = const_var.leanGetDataFront.central_insulation[0].insulation_id;

			params.insulation.center.isCheked = false;
			params.insulation.center.insulationId = 0;
			params.insulation.center.roofOnly = false;
			params.insulation.center.fullBuilding = false;
			params.insulation.center.custom = false;
			params.insulation.center.showInsulationOptions = false;
			params.insulation.center.isDisableFullInsulation = false;
			params.l_t_p = JSON.parse(JSON.stringify(defaultInsulationValues));
		}

		cuBuilding.makeInsulationArrayForLeanto();
		cuBuilding.makeCertificateArrayLeft("front");
		if (const_var.leanGetDataFront.building_structure != undefined && const_var.leanGetDataFront.building_structure.length > 0) {
			if (Object.keys(const_var.leanGetDataFront.building_structure[0].conditions).length !== 0) {
				const_var.ConditionArrForLean["front"] = const_var.leanGetDataFront.building_structure[0].conditions["Leg_Height_condition"];
				checkReinforcedLeg(const_var.ConditionArrForLean["front"]);
			}
		}

		cuBuilding.CheckLeanLegsByResponse(state, type);
		if (
			(!const_var.crmSetting.is_Edit || const_var.isPriceAPIcalled) &&
			(params.fourth_center_cost == true || (const_var.DistanceArr[params.p_b_t][params.p_r_s] != undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s] == 4))
		)
			if (const_var.leanGetDataFront.central_side != undefined && const_var.leanGetDataFront.central_side.length > 0) {
				const_var.a_p_d_a.side = const_var.leanGetDataFront.central_side;
			}
		if (const_var.leanGetDataFront.central_side_full_length != undefined && const_var.leanGetDataFront.central_side_full_length.length > 0) {
			const_var.a_p_d_a.full_length_side = const_var.leanGetDataFront.central_side_full_length;
		}
		if (const_var.leanGetDataFront.central_end != undefined && const_var.leanGetDataFront.central_end.length > 0) {
			const_var.a_p_d_a.end = const_var.leanGetDataFront.central_end;
		}
		if (const_var.leanGetDataFront.central_utility_side != undefined && const_var.leanGetDataFront.central_utility_side.length > 0) {
			const_var.a_p_d_a.utility_side = const_var.leanGetDataFront.central_utility_side;
		}
		if (const_var.leanGetDataFront.end_combo_v3 != undefined && const_var.leanGetDataFront.end_combo_v3.length > 0) {
			const_var.a_p_d_a.end_combo_v3 = const_var.leanGetDataFront.end_combo_v3;
		}
		if (const_var.leanGetDataFront.side_combo_v3 != undefined && const_var.leanGetDataFront.side_combo_v3.length > 0) {
			const_var.a_p_d_a.side_combo_v3 = const_var.leanGetDataFront.side_combo_v3;
		}
		if (const_var.leanGetDataFront.central_trusses != undefined && const_var.leanGetDataFront.central_trusses.length > 0) {
			const_var.a_p_d_a.trusses = const_var.leanGetDataFront.central_trusses;
		}
		utils.updateCenterBuildingPricesOnLeanAPICalls(state, "leanGetDataFront", "front");
		if (const_var.crmSetting.is_Edit != true) {
			if (type != undefined && type == "addFrontLean" && state.params.add_front_lean != true) {
				if (params.p_i_o != 0 && params.p_f_i) updateCenterBuildingInsulation(const_var.a_p_d_a.old_insulation);

				if (state.params.add_left_lean || state.params.add_back_lean || state.params.add_right_lean) {
					if (params.p_i_o != 0 && params.p_f_i) updateCenterBuildingInsulation(const_var.leanGetDataFront.central_insulation);
				}
				const_var.UpdatedPriceData.insulation_price = undefined;
				const_var.UpdatedPriceData.insulation_price_changed = true;
			} else {
				const_var.UpdatedPriceData.front_wall_price_changed = true;
				const_var.UpdatedPriceData.back_wall_price_changed = true;
			}
			const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
			const_var.UpdatedPriceData.height_price_changed = true;
			const_var.UpdatedPriceData.certificate_price_changed = true;
			const_var.UpdatedPriceData.wainscot_price_changed = true;

			const_var.UpdatedPriceData.roof_color_price_changed = true;
			const_var.UpdatedPriceData.wall_color_price_changed = true;
			const_var.UpdatedPriceData.trim_color_price_changed = true;
			const_var.UpdatedPriceData.front_lean_roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.frontLean_truss_price_changed = true;
			if (const_var.a_p_d_a.side[0]?.lift_type != undefined && const_var.a_p_d_a.side[0]?.lift_type != "") {
				const_var.UpdatedPriceData.lifttype_price_changed = true;
				params.lift_type = true;
			}
		} else {
			if (type != undefined && type == "addFrontLean" && state.params.add_front_lean != true) {
				if (params.p_i_o != 0 && params.p_f_i) updateCenterBuildingInsulation(const_var.a_p_d_a.old_insulation);

				if (state.params.add_left_lean || state.params.add_back_lean || state.params.add_right_lean) {
					if (params.p_i_o != 0 && params.p_f_i) updateCenterBuildingInsulation(const_var.leanGetDataFront.central_insulation);
				}
				const_var.UpdatedPriceData.insulation_price = undefined;
				const_var.UpdatedPriceData.insulation_price_changed = true;
			}
		}
		if (const_var.a_p_d_a.connection_fees != undefined && const_var.a_p_d_a.connection_fees.length == 0) {
			const_var.a_p_d_a.connection_fees = const_var.leanGetDataFront.connection_fees;
		}

		if (type == "addFrontLean" && const_var.isLTBuilding) {
			if (const_var.leanGetDataFront?.side_cross_bracing == undefined || const_var.leanGetDataFront?.side_cross_bracing?.length == 0) {
				params.added_building_bracing.p_s_c_b_f = false;
				const_var.selectedBracingForAddedBuilding.front_lean_side = "";
			}
			if (const_var.leanGetDataFront?.side_cross_bracing?.length == 1 && const_var.leanGetDataFront?.side_cross_bracing[0].sheet_name == undefined) {
				const_var.leanGetDataFront.side_cross_bracing[0]["sheet_name"] = "diagonal_braces";
				const_var.leanGetDataFront.side_cross_bracing[0]["sheet_label"] = "Diagonal Braces";
			}

			if (const_var.leanGetDataFront?.side_cross_bracing?.length > 1) {
				let isNoneExsist = const_var.leanGetDataFront.side_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
				if (isNoneExsist == undefined) {
					const_var.leanGetDataFront.side_cross_bracing.push({
						map_id: const_var.leanGetDataFront.side_cross_bracing[0].map_id,
						sheet_name: "none",
						sheet_label: "None",
						is_default: "yes",
						height: const_var.leanGetDataFront.side_cross_bracing[0].height,
						length: const_var.leanGetDataFront.side_cross_bracing[0].length,
						cost: 0
					});
				}
				if (const_var.crmSetting.is_Edit != true) {
					let defaultSelected = const_var.leanGetDataFront.side_cross_bracing.find((obj) => obj.is_default == "included" /* 'yes' */);
					let isBracingExist = const_var.leanGetDataFront.side_cross_bracing?.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.front_lean_side);
					if (defaultSelected != undefined || isBracingExist) {
						const_var.selectedBracingForAddedBuilding.front_lean_side = isBracingExist ? isBracingExist.sheet_name : defaultSelected.sheet_name;
						params.added_building_bracing.p_s_c_b_f = const_var.selectedBracingForAddedBuilding.front_lean_side == "none" ? false : true;
					} else {
						params.added_building_bracing.p_s_c_b_f = false;
						const_var.selectedBracingForAddedBuilding.front_lean_side = "none";
					}
				} else {
					if (const_var.selectedBracingForAddedBuilding.front_lean_side == "") {
						params.added_building_bracing.p_s_c_b_f = false;
						const_var.selectedBracingForAddedBuilding.front_lean_side = "none";
					}
				}
			}

			if (const_var.leanGetDataFront?.side_cross_bracing?.length == 1) {
				if (const_var.leanGetDataFront?.side_cross_bracing[0].is_default != "included") {
					let isNoneExsist = const_var.leanGetDataFront.side_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
					if (isNoneExsist == undefined) {
						const_var.leanGetDataFront.side_cross_bracing.push({
							map_id: const_var.leanGetDataFront.side_cross_bracing[0].map_id,
							sheet_name: "none",
							sheet_label: "None",
							is_default: "yes",
							height: const_var.leanGetDataFront.side_cross_bracing[0].height,
							length: const_var.leanGetDataFront.side_cross_bracing[0].length,
							cost: 0
						});
					}
				}

				let isBracingExsist =
					const_var.selectedBracingForAddedBuilding.front_lean_side != "" && const_var.selectedBracingForAddedBuilding.front_lean_side != "none"
						? const_var.leanGetDataFront.side_cross_bracing.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.front_lean_side)
						: undefined;
				if (isBracingExsist == undefined) {
					if (const_var.leanGetDataFront?.side_cross_bracing[0].is_default == "included") {
						const_var.selectedBracingForAddedBuilding.front_lean_side = const_var.leanGetDataFront?.side_cross_bracing[0].sheet_name;
						params.added_building_bracing.p_s_c_b_f = true;
					} else {
						params.added_building_bracing.p_s_c_b_f = false;
						const_var.selectedBracingForAddedBuilding.front_lean_side = "none";
					}
				}
			}

			if (const_var.leanGetDataFront?.end_cross_bracing == undefined || const_var.leanGetDataFront?.end_cross_bracing?.length == 0) {
				params.added_building_bracing.p_e_c_b_f = false;
				const_var.selectedBracingForAddedBuilding.front_lean_end = "";
			}
			if (const_var.leanGetDataFront?.end_cross_bracing?.length == 1 && const_var.leanGetDataFront?.end_cross_bracing[0].sheet_name == undefined) {
				const_var.leanGetDataFront.end_cross_bracing[0]["sheet_name"] = "diagonal_braces";
				const_var.leanGetDataFront.end_cross_bracing[0]["sheet_label"] = "Diagonal Braces";
			}

			if (const_var.leanGetDataFront?.end_cross_bracing?.length > 1) {
				let isNoneExsist = const_var.leanGetDataFront.end_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
				if (isNoneExsist == undefined) {
					const_var.leanGetDataFront.end_cross_bracing.push({
						map_id: const_var.leanGetDataFront.end_cross_bracing[0].map_id,
						sheet_name: "none",
						sheet_label: "None",
						is_default: "yes",
						height: const_var.leanGetDataFront.end_cross_bracing[0].height,
						length: const_var.leanGetDataFront.end_cross_bracing[0].length,
						cost: 0
					});
				}
				if (const_var.crmSetting.is_Edit != true) {
					let defaultSelected = const_var.leanGetDataFront.end_cross_bracing.find((obj) => obj.is_default == "included" /* 'yes' */);
					let isBracingExist = const_var.leanGetDataFront.end_cross_bracing?.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.front_lean_end);
					if (defaultSelected != undefined || isBracingExist) {
						const_var.selectedBracingForAddedBuilding.front_lean_end = isBracingExist ? isBracingExist.sheet_name : defaultSelected.sheet_name;
						params.added_building_bracing.p_e_c_b_f = const_var.selectedBracingForAddedBuilding.front_lean_end == "none" ? false : true;
					} else {
						params.added_building_bracing.p_e_c_b_f = false;
						const_var.selectedBracingForAddedBuilding.front_lean_end = "none";
					}
				} else {
					if (const_var.selectedBracingForAddedBuilding.front_lean_end == "") {
						params.added_building_bracing.p_e_c_b_f = false;
						const_var.selectedBracingForAddedBuilding.front_lean_end = "none";
					}
				}
			}
			if (const_var.leanGetDataFront?.end_cross_bracing?.length == 1) {
				if (const_var.leanGetDataFront?.end_cross_bracing[0].is_default != "included") {
					let isNoneExsist = const_var.leanGetDataFront.end_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
					if (isNoneExsist == undefined) {
						const_var.leanGetDataFront.end_cross_bracing.push({
							map_id: const_var.leanGetDataFront.end_cross_bracing[0].map_id,
							sheet_name: "none",
							sheet_label: "None",
							is_default: "yes",
							height: const_var.leanGetDataFront.end_cross_bracing[0].height,
							length: const_var.leanGetDataFront.end_cross_bracing[0].length,
							cost: 0
						});
					}
				}

				let isBracingExsist =
					const_var.selectedBracingForAddedBuilding.front_lean_end != "" && const_var.selectedBracingForAddedBuilding.front_lean_end != "none"
						? const_var.leanGetDataFront.end_cross_bracing.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.front_lean_end)
						: undefined;
				if (isBracingExsist == undefined) {
					if (const_var.leanGetDataFront?.end_cross_bracing[0].is_default == "included") {
						const_var.selectedBracingForAddedBuilding.front_lean_end = const_var.leanGetDataFront?.end_cross_bracing[0].sheet_name;
						params.added_building_bracing.p_e_c_b_f = true;
					} else {
						params.added_building_bracing.p_e_c_b_f = false;
						const_var.selectedBracingForAddedBuilding.front_lean_end = "none";
					}
				}
			}
		}

		dataNew = const_var.leanGetDataFront;
		let filterRoofPitchData = "";
		if (params.p_r_s == 1 && params.m_s_n == 13) {
			state.const_var.BuildingLRoofPitch = [];

			filterRoofPitchData = dataNew.roof_pitch != undefined ? dataNew.roof_pitch.filter((data) => params.m_s_n == 13 && params.p_r_s == 1 && data.roof_pitch.split("/")[0] <= 3) : "";
			if (filterRoofPitchData != "" && filterRoofPitchData.length > 0) {
				dataNew.roof_pitch = JSON.parse(JSON.stringify(filterRoofPitchData));
				if (filterRoofPitchData.filter((data) => data.roof_pitch.split("/")[0] == params.b_l_t_r_pF).length == 0) {
					let chkData = filterRoofPitchData.filter((data) => data.is_default == "yes");
					if (chkData.length > 0) {
						params.isDefault_l_t_r_p = params.b_l_t_r_pF = chkData[0].roof_pitch.split("/")[0];
					} else {
						params.isDefault_l_t_r_p = params.b_l_t_r_pF = filterRoofPitchData[0].roof_pitch.split("/")[0];
						cuBuilding.BuildingUpdate(true, "");
					}
				}
			}
		}
		let b_l_t_r_pF_old = state.params.b_l_t_r_pF;
		state.params.b_l_t_r_pF = state.params.b_l_t_r_pF;
		if (dataNew.roof_pitch != undefined && dataNew.roof_pitch.length > 0) {
			state.const_var.b_r_p_l_to_a = [];
			if (!utils.hasGableLeanto("front")) {
				if (state.const_var.BuildingLRoofPitch != undefined && Object.keys(state.const_var.BuildingLRoofPitch).length > 0) {
					Object.keys(state.const_var.BuildingLRoofPitch).map((roofP, idx) => {
						let isRoofPitchExsist = dataNew.roof_pitch.find((obj) => obj.roof_pitch == roofP);
						if (isRoofPitchExsist == undefined) {
							delete state.const_var.BuildingLRoofPitch[roofP];
						}
					});
				}
			}
			let isRoofPitchExsist = false;
			if (params.b_l_t_r_pF && dataNew.roof_pitch.length > 0) {
				isRoofPitchExsist = dataNew.roof_pitch.find((obj) => obj.roof_pitch && obj.roof_pitch.split("/")[0] == params.b_l_t_r_pF);
				isRoofPitchExsist = isRoofPitchExsist != undefined ? true : false;
				if (params.leanStyle.front == "gable") {
					checkRoofPitch(b_l_t_r_pF_old, "front", dataNew);
				}
			}
			for (var i = 0; i <= dataNew.roof_pitch.length - 1; i++) {
				state.const_var.b_r_p_l_to_a[dataNew.roof_pitch[i].roof_pitch.split("/")[0]] = dataNew.roof_pitch[i];
				if (!utils.hasGableLeanto("front")) {
					state.const_var.BuildingLRoofPitch[dataNew.roof_pitch[i].roof_pitch] = dataNew.roof_pitch[i].roof_pitch.split("/")[0];
					state.const_var.leanto_roof_pitch_obj[dataNew.roof_pitch[i].roof_pitch] = dataNew.roof_pitch[i];
				}
				if (dataNew.roof_pitch[i].is_default == "yes" && const_var.checkforLeanto == true) {
					params.isDefault_l_t_r_p = params.b_l_t_r_pF = dataNew.roof_pitch[i].roof_pitch.split("/")[0];
					if (params.leanStyle.front == "gable") {
						checkRoofPitch(b_l_t_r_pF_old, "front", dataNew);
					}
					cuBuilding.UpdateFrontLean();
				}
			}
		}
		if (const_var.crmSetting.is_Edit == false && const_var.defaultBuildingArr[state.defaultBuilding] != undefined) {
			if (
				const_var.checkforLeanto == true &&
				const_var.defaultBuildingArr[state.defaultBuilding].leanto_data != undefined &&
				Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"]).length > 0
			) {
				let isRoofPitchExsist = dataNew.roof_pitch.find((obj) => obj.roof_pitch == const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].roof_pitch);
				if (isRoofPitchExsist != undefined) {
					params.isDefault_l_t_r_p = params.b_l_t_r_pF = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].roof_pitch.split("/")[0];
					state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].roof_pitch] =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].roof_pitch.split("/")[0];
				}

				cuBuilding.UpdateFrontLean();
			} else {
				if (
					const_var.checkforLeanto == true &&
					const_var.defaultBuildingArr[state.defaultBuilding].leanto_data != undefined &&
					Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"]).length == 0 &&
					(const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch != undefined || const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch != null)
				) {
					params.isDefault_l_t_r_p = params.b_l_t_r_pF = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
					state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch] = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
					cuBuilding.UpdateFrontLean();
				}
			}
		}

		if (const_var.checkforLeanto == true) {
			const_var.UpdatedPriceData.height_price_changed = true;
			if (params.p_i_o != 0) {
				const_var.UpdatedPriceData.roof_style_price_changed = true;
			}
			const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;

			const_var.UpdatedPriceData.bothLeanto = true;
			const_var.UpdatedPriceData.connection_fee_end_changed = true;
			const_var.UpdatedPriceData.connection_fee_side_changed = true;
			const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
			const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
			const_var.UpdatedPriceData.common_length_changed = true;
			const_var.UpdatedPriceData.front_wall_price_changed = true;
			const_var.UpdatedPriceData.common_left_lean_length_changed = true;
			const_var.UpdatedPriceData.common_right_lean_length_changed = true;
			const_var.UpdatedPriceData.common_front_lean_length_changed = true;
			const_var.UpdatedPriceData.common_back_lean_length_changed = true;
			const_var.UpdatedPriceData.common_left_lean_width_changed = true;
			const_var.UpdatedPriceData.common_right_lean_width_changed = true;
			const_var.UpdatedPriceData.common_front_lean_width_changed = true;
			const_var.UpdatedPriceData.common_back_lean_width_changed = true;
		}

		utils.checkColoredScrewsForLeanto("front", const_var.leanGetDataFront);
		makeDimensionUpdateFront(state);
		cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
		const_var.checkforLeanto = false;
	} else if (type == "addBackLean") {
		const_var.makeCertificateArrayBack = {};
		const_var.leanGetDataBack = response.success == true ? JSON.parse(JSON.stringify(response.data)) : const_var.leanGetDataBack;

		if (const_var.selectedLeanType == "back") {
			const_var.a_p_d_a = JSON.parse(JSON.stringify(const_var.leanGetDataBack));
		}

		updateTrussId("back", state, const_var.leanGetDataBack);
		updateOverhangOnLeanUpdate("back", state, const_var.leanGetDataBack);

		let buildingStructure = const_var.leanGetDataBack?.building_structure?.[0];
		if (buildingStructure && !(parseFloat(params.leanB_p_h) <= parseFloat(buildingStructure.max_height) && parseFloat(params.leanB_p_h) >= parseFloat(buildingStructure.min_height))) {
			params.leanB_p_h = const_var.leanGetDataBack.building_structure[0].min_height;
		}

		if (
			params.p_c_i == true &&
			response.success == true &&
			response.data.insulation &&
			const_var.leanGetDataBack &&
			const_var.insulationArrayForLeantoBack.insulation_wall &&
			Object.keys(const_var.insulationArrayForLeantoBack.insulation_wall).length > 0
		) {
			let isInsulationAdded = Object.keys(const_var.insulationArrayForLeantoBack.insulation_wall).find((key) => const_var.insulationArrayForLeantoBack.insulation_wall[key] == true);
			params.p_c_i = isInsulationAdded != undefined ? params.p_c_i : false;
			params.p_f_i = false;
		}

		if (const_var.isLTBuilding) {
			updateBracingSelection("back");
		}

		updateCenterBuildingInsulation(const_var.leanGetDataBack.central_insulation);
		if (
			params.p_i_o != 0 &&
			const_var.leanGetDataBack?.central_insulation != undefined &&
			const_var.isInsulaltionForOldQuotes == false &&
			const_var.crmSetting.is_Edit == true &&
			const_var.leanGetDataBack.central_insulation.filter((obj) => obj.insulation_id == params.p_i_o).length == 0
		) {
			params.p_i_o = const_var.leanGetDataBack.central_insulation[0].insulation_id; //0
			params.selectedInsulationId = const_var.leanGetDataBack.central_insulation[0].insulation_id;

			params.insulation.center.isCheked = false;
			params.insulation.center.insulationId = 0;
			params.insulation.center.roofOnly = false;
			params.insulation.center.fullBuilding = false;
			params.insulation.center.custom = false;
			params.insulation.center.showInsulationOptions = false;
			params.insulation.center.isDisableFullInsulation = false;
			params.l_t_p = JSON.parse(JSON.stringify(defaultInsulationValues));
		}

		cuBuilding.makeInsulationArrayForLeanto();
		cuBuilding.makeCertificateArrayLeft("back");
		if (const_var.leanGetDataBack.building_structure != undefined && const_var.leanGetDataBack.building_structure.length > 0) {
			if (Object.keys(const_var.leanGetDataBack.building_structure[0].conditions).length !== 0) {
				const_var.ConditionArrForLean["back"] = const_var.leanGetDataBack.building_structure[0].conditions["Leg_Height_condition"];
				checkReinforcedLeg(const_var.ConditionArrForLean["back"]);
			}
		}

		cuBuilding.CheckLeanLegsByResponse(state, type);
		if (
			(!const_var.crmSetting.is_Edit || const_var.isPriceAPIcalled) &&
			(params.fourth_center_cost == true || (const_var.DistanceArr[params.p_b_t][params.p_r_s] != undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s] == 4))
		) {
		}
		if (const_var.leanGetDataBack.central_side != undefined && const_var.leanGetDataBack.central_side.length > 0) {
			const_var.a_p_d_a.side = const_var.leanGetDataBack.central_side;
		}
		if (const_var.leanGetDataBack.central_side_full_length != undefined && const_var.leanGetDataBack.central_side_full_length.length > 0) {
			const_var.a_p_d_a.full_length_side = const_var.leanGetDataBack.central_side_full_length;
		}
		if (const_var.leanGetDataBack.central_end != undefined && const_var.leanGetDataBack.central_end.length > 0) {
			const_var.a_p_d_a.end = const_var.leanGetDataBack.central_end;
		}
		if (const_var.leanGetDataBack.central_utility_side != undefined && const_var.leanGetDataBack.central_utility_side.length > 0) {
			const_var.a_p_d_a.utility_side = const_var.leanGetDataBack.central_utility_side;
		}
		if (const_var.leanGetDataBack.end_combo_v3 != undefined && const_var.leanGetDataBack.end_combo_v3.length > 0) {
			const_var.a_p_d_a.end_combo_v3 = const_var.leanGetDataBack.end_combo_v3;
		}
		if (const_var.leanGetDataBack.side_combo_v3 != undefined && const_var.leanGetDataBack.side_combo_v3.length > 0) {
			const_var.a_p_d_a.side_combo_v3 = const_var.leanGetDataBack.side_combo_v3;
		}
		if (const_var.leanGetDataBack.central_trusses != undefined && const_var.leanGetDataBack.central_trusses.length > 0) {
			const_var.a_p_d_a.trusses = const_var.leanGetDataBack.central_trusses;
		}
		utils.updateCenterBuildingPricesOnLeanAPICalls(state, "leanGetDataBack", "back");
		if (const_var.crmSetting.is_Edit != true) {
			if (type != undefined && type == "addBackLean" && state.params.add_back_lean != true) {
				if (params.p_i_o != 0 && params.p_f_i) updateCenterBuildingInsulation(const_var.a_p_d_a.old_insulation);

				if (state.params.add_left_lean || state.params.add_front_lean || state.params.add_right_lean) {
					if (params.p_i_o != 0 && params.p_f_i) updateCenterBuildingInsulation(const_var.leanGetDataBack.central_insulation);
				}
				const_var.UpdatedPriceData.insulation_price = undefined;
				const_var.UpdatedPriceData.insulation_price_changed = true;
			} else {
				const_var.UpdatedPriceData.front_wall_price_changed = true;
				const_var.UpdatedPriceData.back_wall_price_changed = true;
			}
			const_var.UpdatedPriceData.height_price_changed = true;
			const_var.UpdatedPriceData.certificate_price_changed = true;
			const_var.UpdatedPriceData.wainscot_price_changed = true;
			const_var.UpdatedPriceData.roof_color_price_changed = true;
			const_var.UpdatedPriceData.wall_color_price_changed = true;
			const_var.UpdatedPriceData.trim_color_price_changed = true;
			const_var.UpdatedPriceData.back_lean_roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
			const_var.UpdatedPriceData.backLean_truss_price_changed = true;
			if (const_var.a_p_d_a.side[0]?.lift_type != undefined && const_var.a_p_d_a.side[0]?.lift_type != "") {
				const_var.UpdatedPriceData.lifttype_price_changed = true;
				params.lift_type = true;
			}
		} else {
			if (type != undefined && type == "addBackLean" && state.params.add_back_lean != true) {
				if (params.p_i_o != 0 && params.p_f_i) updateCenterBuildingInsulation(const_var.a_p_d_a.old_insulation);

				if (state.params.add_left_lean || state.params.add_front_lean || state.params.add_right_lean) {
					if (params.p_i_o != 0 && params.p_f_i) updateCenterBuildingInsulation(const_var.leanGetDataBack.central_insulation);
				}
				const_var.UpdatedPriceData.insulation_price = undefined;
				const_var.UpdatedPriceData.insulation_price_changed = true;
			}
		}
		if (const_var.a_p_d_a.connection_fees != undefined && const_var.a_p_d_a.connection_fees.length == 0) {
			const_var.a_p_d_a.connection_fees = const_var.leanGetDataBack.connection_fees;
		}

		if (type == "addBackLean" && const_var.isLTBuilding) {
			if (const_var.leanGetDataBack?.side_cross_bracing == undefined || const_var.leanGetDataBack?.side_cross_bracing?.length == 0) {
				params.added_building_bracing.p_s_c_b_b = false;
				const_var.selectedBracingForAddedBuilding.back_lean_side = "";
			}
			if (const_var.leanGetDataBack?.side_cross_bracing?.length == 1 && const_var.leanGetDataBack?.side_cross_bracing[0].sheet_name == undefined) {
				const_var.leanGetDataBack.side_cross_bracing[0]["sheet_name"] = "diagonal_braces";
				const_var.leanGetDataBack.side_cross_bracing[0]["sheet_label"] = "Diagonal Braces";
			}
			if (const_var.leanGetDataBack?.side_cross_bracing?.length > 1) {
				let isNoneExsist = const_var.leanGetDataBack.side_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
				if (isNoneExsist == undefined) {
					const_var.leanGetDataBack.side_cross_bracing.push({
						map_id: const_var.leanGetDataBack.side_cross_bracing[0].map_id,
						sheet_name: "none",
						sheet_label: "None",
						is_default: "yes",
						height: const_var.leanGetDataBack.side_cross_bracing[0].height,
						length: const_var.leanGetDataBack.side_cross_bracing[0].length,
						cost: 0
					});
				}
				if (const_var.crmSetting.is_Edit != true) {
					let defaultSelected = const_var.leanGetDataBack.side_cross_bracing.find((obj) => obj.is_default == "included" /* 'yes' */);
					let isBracingExist = const_var.leanGetDataBack.side_cross_bracing?.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.back_lean_side);
					if (defaultSelected != undefined || isBracingExist) {
						const_var.selectedBracingForAddedBuilding.back_lean_side = isBracingExist ? isBracingExist.sheet_name : defaultSelected.sheet_name;
						params.added_building_bracing.p_s_c_b_b = const_var.selectedBracingForAddedBuilding.back_lean_side == "none" ? false : true;
					} else {
						params.added_building_bracing.p_s_c_b_b = false;
						const_var.selectedBracingForAddedBuilding.back_lean_side = "none";
					}
				} else {
					if (const_var.selectedBracingForAddedBuilding.back_lean_side == "") {
						params.added_building_bracing.p_s_c_b_b = false;
						const_var.selectedBracingForAddedBuilding.back_lean_side = "none";
					}
				}
			}

			if (const_var.leanGetDataBack?.side_cross_bracing?.length == 1) {
				if (const_var.leanGetDataBack?.side_cross_bracing[0].is_default != "included") {
					let isNoneExsist = const_var.leanGetDataBack.side_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
					if (isNoneExsist == undefined) {
						const_var.leanGetDataBack.side_cross_bracing.push({
							map_id: const_var.leanGetDataBack.side_cross_bracing[0].map_id,
							sheet_name: "none",
							sheet_label: "None",
							is_default: "yes",
							height: const_var.leanGetDataBack.side_cross_bracing[0].height,
							length: const_var.leanGetDataBack.side_cross_bracing[0].length,
							cost: 0
						});
					}
				}

				let isBracingExsist =
					const_var.selectedBracingForAddedBuilding.back_lean_side != "" && const_var.selectedBracingForAddedBuilding.back_lean_side != "none"
						? const_var.leanGetDataBack.side_cross_bracing.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.back_lean_side)
						: undefined;
				if (isBracingExsist == undefined) {
					if (const_var.leanGetDataBack?.side_cross_bracing[0].is_default == "included") {
						const_var.selectedBracingForAddedBuilding.back_lean_side = const_var.leanGetDataBack?.side_cross_bracing[0].sheet_name;
						params.added_building_bracing.p_s_c_b_b = true;
					} else {
						params.added_building_bracing.p_s_c_b_b = false;
						const_var.selectedBracingForAddedBuilding.back_lean_side = "none";
					}
				}
			}

			if (const_var.leanGetDataBack?.end_cross_bracing == undefined || const_var.leanGetDataBack?.end_cross_bracing?.length == 0) {
				params.added_building_bracing.p_e_c_b_b = false;
				const_var.selectedBracingForAddedBuilding.back_lean_end = "";
			}
			if (const_var.leanGetDataBack?.end_cross_bracing?.length == 1 && const_var.leanGetDataBack?.end_cross_bracing[0].sheet_name == undefined) {
				const_var.leanGetDataBack.end_cross_bracing[0]["sheet_name"] = "diagonal_braces";
				const_var.leanGetDataBack.end_cross_bracing[0]["sheet_label"] = "Diagonal Braces";
			}

			if (const_var.leanGetDataBack?.end_cross_bracing?.length > 1) {
				let isNoneExsist = const_var.leanGetDataBack.end_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
				if (isNoneExsist == undefined) {
					const_var.leanGetDataBack.end_cross_bracing.push({
						map_id: const_var.leanGetDataBack.end_cross_bracing[0].map_id,
						sheet_name: "none",
						sheet_label: "None",
						is_default: "yes",
						height: const_var.leanGetDataBack.end_cross_bracing[0].height,
						length: const_var.leanGetDataBack.end_cross_bracing[0].length,
						cost: 0
					});
				}
				if (const_var.crmSetting.is_Edit != true) {
					let defaultSelected = const_var.leanGetDataBack.end_cross_bracing.find((obj) => obj.is_default == "included" /* 'yes' */);
					let isBracingExist = const_var.leanGetDataBack.end_cross_bracing?.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.back_lean_end);
					if (defaultSelected != undefined || isBracingExist) {
						const_var.selectedBracingForAddedBuilding.back_lean_end = isBracingExist ? isBracingExist.sheet_name : defaultSelected.sheet_name;
						params.added_building_bracing.p_e_c_b_b = const_var.selectedBracingForAddedBuilding.back_lean_end == "none" ? false : true;
					} else {
						params.added_building_bracing.p_e_c_b_b = false;
						const_var.selectedBracingForAddedBuilding.back_lean_end = "none";
					}
				} else {
					if (const_var.selectedBracingForAddedBuilding.back_lean_end == "") {
						params.added_building_bracing.p_e_c_b_b = false;
						const_var.selectedBracingForAddedBuilding.back_lean_end = "none";
					}
				}
			}
			if (const_var.leanGetDataBack?.end_cross_bracing?.length == 1) {
				if (const_var.leanGetDataBack?.end_cross_bracing[0].is_default != "included") {
					let isNoneExsist = const_var.leanGetDataBack.end_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
					if (isNoneExsist == undefined) {
						const_var.leanGetDataBack.end_cross_bracing.push({
							map_id: const_var.leanGetDataBack.end_cross_bracing[0].map_id,
							sheet_name: "none",
							sheet_label: "None",
							is_default: "yes",
							height: const_var.leanGetDataBack.end_cross_bracing[0].height,
							length: const_var.leanGetDataBack.end_cross_bracing[0].length,
							cost: 0
						});
					}
				}

				let isBracingExsist =
					const_var.selectedBracingForAddedBuilding.back_lean_end != "" && const_var.selectedBracingForAddedBuilding.back_lean_end != "none"
						? const_var.leanGetDataBack.end_cross_bracing.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.back_lean_end)
						: undefined;
				if (isBracingExsist == undefined) {
					if (const_var.leanGetDataBack?.end_cross_bracing[0].is_default == "included") {
						const_var.selectedBracingForAddedBuilding.back_lean_end = const_var.leanGetDataBack?.end_cross_bracing[0].sheet_name;
						params.added_building_bracing.p_e_c_b_b = true;
					} else {
						params.added_building_bracing.p_e_c_b_b = false;
						const_var.selectedBracingForAddedBuilding.back_lean_end = "none";
					}
				}
			}
		}
		dataNew = const_var.leanGetDataBack;
		let filterRoofPitchData = "";
		if (params.p_r_s == 1 && params.m_s_n == 13) {
			state.const_var.BuildingLRoofPitch = [];

			filterRoofPitchData = dataNew.roof_pitch != undefined ? dataNew.roof_pitch.filter((data) => params.m_s_n == 13 && params.p_r_s == 1 && data.roof_pitch.split("/")[0] <= 3) : "";
			if (filterRoofPitchData != "" && filterRoofPitchData.length > 0) {
				dataNew.roof_pitch = JSON.parse(JSON.stringify(filterRoofPitchData));
				if (filterRoofPitchData.filter((data) => data.roof_pitch.split("/")[0] == params.b_l_t_r_pB).length == 0) {
					let chkData = filterRoofPitchData.filter((data) => data.is_default == "yes");
					if (chkData.length > 0) {
						params.isDefault_l_t_r_p = params.b_l_t_r_pB = chkData[0].roof_pitch.split("/")[0];
					} else {
						params.isDefault_l_t_r_p = params.b_l_t_r_pB = filterRoofPitchData[0].roof_pitch.split("/")[0];
						cuBuilding.BuildingUpdate(true, "");
					}
				}
			}
		}
		let b_l_t_r_pB_old = state.params.b_l_t_r_pB;
		state.params.b_l_t_r_pB = state.params.b_l_t_r_pB;
		if (dataNew.roof_pitch != undefined && dataNew.roof_pitch.length > 0) {
			state.const_var.b_r_p_l_to_a = [];
			if (!utils.hasGableLeanto("back")) {
				if (state.const_var.BuildingLRoofPitch != undefined && Object.keys(state.const_var.BuildingLRoofPitch).length > 0) {
					Object.keys(state.const_var.BuildingLRoofPitch).map((roofP, idx) => {
						let isRoofPitchExsist = dataNew.roof_pitch.find((obj) => obj.roof_pitch == roofP);
						if (isRoofPitchExsist == undefined) {
							delete state.const_var.BuildingLRoofPitch[roofP];
						}
					});
				}
			}
			let isRoofPitchExsist = false;
			if (params.b_l_t_r_pB && dataNew.roof_pitch.length > 0) {
				isRoofPitchExsist = dataNew.roof_pitch.find((obj) => obj.roof_pitch && obj.roof_pitch.split("/")[0] == params.b_l_t_r_pB);
				isRoofPitchExsist = isRoofPitchExsist != undefined ? true : false;
				if (params.leanStyle.back == "gable") {
					checkRoofPitch(b_l_t_r_pB_old, "back", dataNew);
				}
			}
			for (var i = 0; i <= dataNew.roof_pitch.length - 1; i++) {
				state.const_var.b_r_p_l_to_a[dataNew.roof_pitch[i].roof_pitch.split("/")[0]] = dataNew.roof_pitch[i];
				if (!utils.hasGableLeanto("back")) {
					state.const_var.BuildingLRoofPitch[dataNew.roof_pitch[i].roof_pitch] = dataNew.roof_pitch[i].roof_pitch.split("/")[0];
					state.const_var.leanto_roof_pitch_obj[dataNew.roof_pitch[i].roof_pitch] = dataNew.roof_pitch[i];
				}
				if (dataNew.roof_pitch[i].is_default == "yes" && const_var.checkforLeanto == true) {
					params.isDefault_l_t_r_p = params.b_l_t_r_pB = dataNew.roof_pitch[i].roof_pitch.split("/")[0];
					if (params.leanStyle.back == "gable") {
						checkRoofPitch(b_l_t_r_pB_old, "back", dataNew);
					}
					cuBuilding.UpdateBackLean();
				}
			}
		}
		if (const_var.crmSetting.is_Edit == false && const_var.defaultBuildingArr[state.defaultBuilding] != undefined) {
			if (
				const_var.checkforLeanto == true &&
				const_var.defaultBuildingArr[state.defaultBuilding].leanto_data != undefined &&
				Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"]).length > 0
			) {
				let isRoofPitchExsist = dataNew.roof_pitch.find((obj) => obj.roof_pitch == const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].roof_pitch);
				if (isRoofPitchExsist != undefined) {
					params.isDefault_l_t_r_p = params.b_l_t_r_pB = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].roof_pitch.split("/")[0];
					state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].roof_pitch] =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].roof_pitch.split("/")[0];
				}

				cuBuilding.UpdateBackLean();
			} else {
				if (
					const_var.checkforLeanto == true &&
					const_var.defaultBuildingArr[state.defaultBuilding].leanto_data != undefined &&
					Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"]).length == 0 &&
					(const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch != undefined || const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch != null)
				) {
					params.isDefault_l_t_r_p = params.b_l_t_r_pB = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
					state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch] = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
					cuBuilding.UpdateBackLean();
				}
			}
		}

		if (const_var.checkforLeanto == true) {
			const_var.UpdatedPriceData.height_price_changed = true;
			if (params.p_i_o != 0) {
				const_var.UpdatedPriceData.roof_style_price_changed = true;
			}
			const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;

			const_var.UpdatedPriceData.bothLeanto = true;
			const_var.UpdatedPriceData.connection_fee_end_changed = true;
			const_var.UpdatedPriceData.connection_fee_side_changed = true;
			const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
			const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
			const_var.UpdatedPriceData.common_length_changed = true;
			const_var.UpdatedPriceData.back_wall_price_changed = true;
			const_var.UpdatedPriceData.common_left_lean_length_changed = true;
			const_var.UpdatedPriceData.common_right_lean_length_changed = true;
			const_var.UpdatedPriceData.common_front_lean_length_changed = true;
			const_var.UpdatedPriceData.common_back_lean_length_changed = true;
			const_var.UpdatedPriceData.common_left_lean_width_changed = true;
			const_var.UpdatedPriceData.common_right_lean_width_changed = true;
			const_var.UpdatedPriceData.common_front_lean_width_changed = true;
			const_var.UpdatedPriceData.common_back_lean_width_changed = true;
		}

		utils.checkColoredScrewsForLeanto("back", const_var.leanGetDataBack);
		makeDimensionUpdateBack(state);
		cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
		const_var.checkforLeanto = false;
	} else if (type == "addRightLean") {
		const_var.makeCertificateArrayRight = {};
		const_var.leanGetDataRight = response.success == true ? JSON.parse(JSON.stringify(response.data)) : const_var.leanGetDataRight;

		if (const_var.selectedLeanType == "right") {
			const_var.a_p_d_a = JSON.parse(JSON.stringify(const_var.leanGetDataRight));
		}

		updateTrussId("right", state, const_var.leanGetDataRight);
		updateOverhangOnLeanUpdate("right", state, const_var.leanGetDataRight);

		let buildingStructure = const_var.leanGetDataRight?.building_structure?.[0];
		if (buildingStructure && !(parseFloat(params.leanR_p_h) <= parseFloat(buildingStructure.max_height) && parseFloat(params.leanR_p_h) >= parseFloat(buildingStructure.min_height))) {
			params.leanR_p_h = const_var.leanGetDataRight.building_structure[0].min_height;
		}
		if (
			params.p_c_i == true &&
			response.success == true &&
			response.data.insulation &&
			const_var.leanGetDataRight &&
			const_var.insulationArrayForLeantoRight.insulation_wall &&
			Object.keys(const_var.insulationArrayForLeantoRight.insulation_wall).length > 0
		) {
			let isInsulationAdded = Object.keys(const_var.insulationArrayForLeantoRight.insulation_wall).find((key) => const_var.insulationArrayForLeantoRight.insulation_wall[key] == true);
			params.p_c_i = isInsulationAdded != undefined ? params.p_c_i : false;
			params.p_f_i = false;
		}

		if (const_var.isLTBuilding) {
			updateBracingSelection("right");
		}

		updateCenterBuildingInsulation(const_var.leanGetDataRight.central_insulation);
		if (
			params.p_i_o != 0 &&
			const_var.leanGetDataRight?.central_insulation != undefined &&
			const_var.isInsulaltionForOldQuotes == false &&
			const_var.crmSetting.is_Edit == true &&
			const_var.leanGetDataRight.central_insulation.filter((obj) => obj.insulation_id == params.p_i_o).length == 0
		) {
			params.p_i_o = const_var.leanGetDataRight.central_insulation[0].insulation_id; //0
			params.selectedInsulationId = const_var.leanGetDataRight.central_insulation[0].insulation_id;

			params.insulation.center.isCheked = false;
			params.insulation.center.insulationId = 0;
			params.insulation.center.roofOnly = false;
			params.insulation.center.fullBuilding = false;
			params.insulation.center.custom = false;
			params.insulation.center.showInsulationOptions = false;
			params.insulation.center.isDisableFullInsulation = false;
			params.l_t_p = JSON.parse(JSON.stringify(defaultInsulationValues));
		}
		cuBuilding.makeInsulationArrayForLeanto();
		cuBuilding.makeCertificateArrayLeft("right");
		if (const_var.leanGetDataRight.building_structure != undefined && const_var.leanGetDataRight.building_structure.length > 0) {
			if (Object.keys(const_var.leanGetDataRight.building_structure[0].conditions).length !== 0) {
				const_var.ConditionArrForLean["right"] = const_var.leanGetDataRight.building_structure[0].conditions["Leg_Height_condition"];
				checkReinforcedLeg(const_var.ConditionArrForLean["right"]);
			}
		}
		cuBuilding.CheckLeanLegsByResponse(state, type);
		if (const_var.leanGetDataRight.central_side != undefined && const_var.leanGetDataRight.central_side.length > 0) {
			const_var.a_p_d_a.side = const_var.leanGetDataRight.central_side;
		}
		if (const_var.leanGetDataRight.central_side_full_length != undefined && const_var.leanGetDataRight.central_side_full_length.length > 0) {
			const_var.a_p_d_a.full_length_side = const_var.leanGetDataRight.central_side_full_length;
		}
		if (const_var.leanGetDataRight.central_end != undefined && const_var.leanGetDataRight.central_end.length > 0) {
			const_var.a_p_d_a.end = const_var.leanGetDataRight.central_end;
		}
		if (const_var.leanGetDataRight.central_utility_side != undefined && const_var.leanGetDataRight.central_utility_side.length > 0) {
			const_var.a_p_d_a.utility_side = const_var.leanGetDataRight.central_utility_side;
		}
		if (const_var.leanGetDataRight.end_combo_v3 != undefined && const_var.leanGetDataRight.end_combo_v3.length > 0) {
			const_var.a_p_d_a.end_combo_v3 = const_var.leanGetDataRight.end_combo_v3;
		}
		if (const_var.leanGetDataRight.side_combo_v3 != undefined && const_var.leanGetDataRight.side_combo_v3.length > 0) {
			const_var.a_p_d_a.side_combo_v3 = const_var.leanGetDataRight.side_combo_v3;
		}
		if (const_var.leanGetDataRight.central_trusses != undefined && const_var.leanGetDataRight.central_trusses.length > 0) {
			const_var.a_p_d_a.trusses = const_var.leanGetDataRight.central_trusses;
		}
		utils.updateCenterBuildingPricesOnLeanAPICalls(state, "leanGetDataRight", "right");
		if (const_var.crmSetting.is_Edit != true) {
			if (type != undefined && type == "addRightLean" && state.params.add_right_lean != true) {
				if (params.p_i_o != 0 && params.p_f_i) updateCenterBuildingInsulation(const_var.a_p_d_a.old_insulation);

				if (state.params.add_left_lean || state.params.add_front_lean || state.params.add_back_lean) {
					if (params.p_i_o != 0 && params.p_f_i) updateCenterBuildingInsulation(const_var.leanGetDataRight.central_insulation);
				}
				const_var.UpdatedPriceData.insulation_price = undefined;
				const_var.UpdatedPriceData.insulation_price_changed = true;
			} else {
				const_var.UpdatedPriceData.front_wall_price_changed = true;
				const_var.UpdatedPriceData.back_wall_price_changed = true;
			}
			const_var.UpdatedPriceData.height_price_changed = true;
			const_var.UpdatedPriceData.certificate_price_changed = true;
			const_var.UpdatedPriceData.wainscot_price_changed = true;

			const_var.UpdatedPriceData.roof_color_price_changed = true;
			const_var.UpdatedPriceData.wall_color_price_changed = true;
			const_var.UpdatedPriceData.trim_color_price_changed = true;
			const_var.UpdatedPriceData.right_lean_roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
			const_var.UpdatedPriceData.rightLean_truss_price_changed = true;
			if (const_var.a_p_d_a.side[0]?.lift_type != undefined && const_var.a_p_d_a.side[0]?.lift_type != "") {
				const_var.UpdatedPriceData.lifttype_price_changed = true;
				params.lift_type = true;
			}
		} else {
			if (type != undefined && type == "addRightLean" && state.params.add_right_lean != true) {
				if (params.p_i_o != 0 && params.p_f_i) updateCenterBuildingInsulation(const_var.a_p_d_a.old_insulation);

				if (state.params.add_left_lean || state.params.add_front_lean || state.params.add_back_lean) {
					if (params.p_i_o != 0 && params.p_f_i) updateCenterBuildingInsulation(const_var.leanGetDataRight.central_insulation);
				}
				const_var.UpdatedPriceData.insulation_price = undefined;
				const_var.UpdatedPriceData.insulation_price_changed = true;
			}
		}
		if (const_var.a_p_d_a.connection_fees != undefined && const_var.a_p_d_a.connection_fees.length == 0) {
			const_var.a_p_d_a.connection_fees = const_var.leanGetDataRight.connection_fees;
		}

		if (type == "addRightLean" && const_var.isLTBuilding) {
			if (const_var.leanGetDataRight?.side_cross_bracing == undefined || const_var.leanGetDataRight?.side_cross_bracing?.length == 0) {
				params.added_building_bracing.p_s_c_b_r = false;
				const_var.selectedBracingForAddedBuilding.right_lean_side = "";
			}
			if (const_var.leanGetDataRight?.side_cross_bracing?.length == 1 && const_var.leanGetDataRight?.side_cross_bracing[0].sheet_name == undefined) {
				const_var.leanGetDataRight.side_cross_bracing[0]["sheet_name"] = "diagonal_braces";
				const_var.leanGetDataRight.side_cross_bracing[0]["sheet_label"] = "Diagonal Braces";
			}
			if (const_var.leanGetDataRight?.side_cross_bracing?.length > 1) {
				let isNoneExsist = const_var.leanGetDataRight.side_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
				if (isNoneExsist == undefined) {
					const_var.leanGetDataRight.side_cross_bracing.push({
						map_id: const_var.leanGetDataRight.side_cross_bracing[0].map_id,
						sheet_name: "none",
						sheet_label: "None",
						is_default: "yes",
						height: const_var.leanGetDataRight.side_cross_bracing[0].height,
						length: const_var.leanGetDataRight.side_cross_bracing[0].length,
						cost: 0
					});
				}
				if (const_var.crmSetting.is_Edit != true) {
					let defaultSelected = const_var.leanGetDataRight.side_cross_bracing.find((obj) => obj.is_default == "included");
					let isBracingExist = const_var.leanGetDataRight.side_cross_bracing?.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.right_lean_side);
					if (defaultSelected != undefined || isBracingExist) {
						const_var.selectedBracingForAddedBuilding.right_lean_side = isBracingExist ? isBracingExist.sheet_name : defaultSelected.sheet_name;
						params.added_building_bracing.p_s_c_b_r = const_var.selectedBracingForAddedBuilding.right_lean_side == "none" ? false : true;
					} else {
						params.added_building_bracing.p_s_c_b_r = false;
						const_var.selectedBracingForAddedBuilding.right_lean_side = "none";
					}
				} else {
					if (const_var.selectedBracingForAddedBuilding.right_lean_side == "") {
						params.added_building_bracing.p_s_c_b_r = false;
						const_var.selectedBracingForAddedBuilding.right_lean_side = "none";
					}
				}
			}
			if (const_var.leanGetDataRight?.side_cross_bracing?.length == 1) {
				if (const_var.leanGetDataRight?.side_cross_bracing[0].is_default != "included") {
					let isNoneExsist = const_var.leanGetDataRight.side_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
					if (isNoneExsist == undefined) {
						const_var.leanGetDataRight.side_cross_bracing.push({
							map_id: const_var.leanGetDataRight.side_cross_bracing[0].map_id,
							sheet_name: "none",
							sheet_label: "None",
							is_default: "yes",
							height: const_var.leanGetDataRight.side_cross_bracing[0].height,
							length: const_var.leanGetDataRight.side_cross_bracing[0].length,
							cost: 0
						});
					}
				}

				let isBracingExsist =
					const_var.selectedBracingForAddedBuilding.right_lean_side != "" && const_var.selectedBracingForAddedBuilding.right_lean_side != "none"
						? const_var.leanGetDataRight.side_cross_bracing.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.right_lean_side)
						: undefined;
				if (isBracingExsist == undefined) {
					if (const_var.leanGetDataRight?.side_cross_bracing[0].is_default == "included") {
						const_var.selectedBracingForAddedBuilding.right_lean_side = const_var.leanGetDataRight?.side_cross_bracing[0].sheet_name;
						params.added_building_bracing.p_s_c_b_r = true;
					} else {
						params.added_building_bracing.p_s_c_b_r = false;
						const_var.selectedBracingForAddedBuilding.right_lean_side = "none";
					}
				}
			}

			if (const_var.leanGetDataRight?.end_cross_bracing == undefined || const_var.leanGetDataRight?.end_cross_bracing?.length == 0) {
				params.added_building_bracing.p_e_c_b_r = false;
				const_var.selectedBracingForAddedBuilding.right_lean_end = "";
			}
			if (const_var.leanGetDataRight?.end_cross_bracing?.length == 1 && const_var.leanGetDataRight?.end_cross_bracing[0].sheet_name == undefined) {
				const_var.leanGetDataRight.end_cross_bracing[0]["sheet_name"] = "diagonal_braces";
				const_var.leanGetDataRight.end_cross_bracing[0]["sheet_label"] = "Diagonal Braces";
			}

			if (const_var.leanGetDataRight?.end_cross_bracing?.length > 1) {
				let isNoneExsist = const_var.leanGetDataRight.end_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
				if (isNoneExsist == undefined) {
					const_var.leanGetDataRight.end_cross_bracing.push({
						map_id: const_var.leanGetDataRight.end_cross_bracing[0].map_id,
						sheet_name: "none",
						sheet_label: "None",
						is_default: "yes",
						height: const_var.leanGetDataRight.end_cross_bracing[0].height,
						length: const_var.leanGetDataRight.end_cross_bracing[0].length,
						cost: 0
					});
				}
				if (const_var.crmSetting.is_Edit != true) {
					let defaultSelected = const_var.leanGetDataRight.end_cross_bracing.find((obj) => obj.is_default == "included" /* 'yes' */);
					let isBracingExist = const_var.leanGetDataRight.end_cross_bracing?.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.right_lean_end);
					if (defaultSelected != undefined || isBracingExist) {
						const_var.selectedBracingForAddedBuilding.right_lean_end = isBracingExist ? isBracingExist.sheet_name : defaultSelected.sheet_name;
						params.added_building_bracing.p_e_c_b_r = const_var.selectedBracingForAddedBuilding.right_lean_end == "none" ? false : true;
					} else {
						params.added_building_bracing.p_e_c_b_r = false;
						const_var.selectedBracingForAddedBuilding.right_lean_end = "none";
					}
				} else {
					if (const_var.selectedBracingForAddedBuilding.right_lean_end == "") {
						params.added_building_bracing.p_e_c_b_r = false;
						const_var.selectedBracingForAddedBuilding.right_lean_end = "none";
					}
				}
			}
			if (const_var.leanGetDataRight?.end_cross_bracing?.length == 1) {
				if (const_var.leanGetDataRight?.end_cross_bracing[0].is_default != "included") {
					let isNoneExsist = const_var.leanGetDataRight.end_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
					if (isNoneExsist == undefined) {
						const_var.leanGetDataRight.end_cross_bracing.push({
							map_id: const_var.leanGetDataRight.end_cross_bracing[0].map_id,
							sheet_name: "none",
							sheet_label: "None",
							is_default: "yes",
							height: const_var.leanGetDataRight.end_cross_bracing[0].height,
							length: const_var.leanGetDataRight.end_cross_bracing[0].length,
							cost: 0
						});
					}
				}

				let isBracingExsist =
					const_var.selectedBracingForAddedBuilding.right_lean_end != "" && const_var.selectedBracingForAddedBuilding.right_lean_end != "none"
						? const_var.leanGetDataRight.end_cross_bracing.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.right_lean_end)
						: undefined;
				if (isBracingExsist == undefined) {
					if (const_var.leanGetDataRight?.end_cross_bracing[0].is_default == "included") {
						const_var.selectedBracingForAddedBuilding.right_lean_end = const_var.leanGetDataRight?.end_cross_bracing[0].sheet_name;
						params.added_building_bracing.p_e_c_b_r = true;
					} else {
						params.added_building_bracing.p_e_c_b_r = false;
						const_var.selectedBracingForAddedBuilding.right_lean_end = "none";
					}
				}
			}
		}
		dataNew = const_var.leanGetDataRight;
		let filterRoofPitchData = "";
		if (params.p_r_s == 1 && params.m_s_n == 13) {
			state.const_var.BuildingLRoofPitch = [];

			filterRoofPitchData = dataNew.roof_pitch != undefined ? dataNew.roof_pitch.filter((data) => params.m_s_n == 13 && params.p_r_s == 1 && data.roof_pitch.split("/")[0] <= 3) : "";
			if (filterRoofPitchData != "" && filterRoofPitchData.length > 0) {
				dataNew.roof_pitch = JSON.parse(JSON.stringify(filterRoofPitchData));
				if (filterRoofPitchData.filter((data) => data.roof_pitch.split("/")[0] == params.b_l_t_r_pR).length == 0) {
					let chkData = filterRoofPitchData.filter((data) => data.is_default == "yes");
					if (chkData.length > 0) {
						params.isDefault_l_t_r_p = params.b_l_t_r_pR = chkData[0].roof_pitch.split("/")[0];
					} else {
						params.isDefault_l_t_r_p = params.b_l_t_r_pR = filterRoofPitchData[0].roof_pitch.split("/")[0];
						cuBuilding.BuildingUpdate(true, "");
					}
				}
			}
		}
		let b_l_t_r_pR_old = state.params.b_l_t_r_pR;
		state.params.b_l_t_r_pR = state.params.b_l_t_r_pR;
		if (dataNew.roof_pitch != undefined && dataNew.roof_pitch.length > 0) {
			state.const_var.b_r_p_l_to_a = [];
			if (!utils.hasGableLeanto("right")) {
				if (state.const_var.BuildingLRoofPitch != undefined && Object.keys(state.const_var.BuildingLRoofPitch).length > 0) {
					Object.keys(state.const_var.BuildingLRoofPitch).map((roofP, idx) => {
						let isRoofPitchExsist = dataNew.roof_pitch.find((obj) => obj.roof_pitch == roofP);
						if (isRoofPitchExsist == undefined) {
							delete state.const_var.BuildingLRoofPitch[roofP];
						}
					});
				}
			}
			let isRoofPitchExsist = false;
			if (params.b_l_t_r_pR && dataNew.roof_pitch.length > 0) {
				isRoofPitchExsist = dataNew.roof_pitch.find((obj) => obj.roof_pitch && obj.roof_pitch.split("/")[0] == params.b_l_t_r_pR);
				isRoofPitchExsist = isRoofPitchExsist != undefined ? true : false;
				if (params.leanStyle.right == "gable") {
					checkRoofPitch(b_l_t_r_pR_old, "right", dataNew);
				}
			}
			for (var i = 0; i <= dataNew.roof_pitch.length - 1; i++) {
				state.const_var.b_r_p_l_to_a[dataNew.roof_pitch[i].roof_pitch.split("/")[0]] = dataNew.roof_pitch[i];
				if (!utils.hasGableLeanto("right")) {
					state.const_var.BuildingLRoofPitch[dataNew.roof_pitch[i].roof_pitch] = dataNew.roof_pitch[i].roof_pitch.split("/")[0];
					state.const_var.leanto_roof_pitch_obj[dataNew.roof_pitch[i].roof_pitch] = dataNew.roof_pitch[i];
				}
				if (dataNew.roof_pitch[i].is_default == "yes" && const_var.checkforLeanto == true) {
					let buildingName = const_var.defaultBuildingArr[const_var.BuldingIDforReset] && const_var.defaultBuildingArr[const_var.BuldingIDforReset]?.image_name?.split(".")?.includes("Straight_Roof_Barns");

					let checkType =
						params.m_s_n == 3 &&
						buildingName &&
						((const_var.editAPIDataByResponse.data?.main_created_at >= "2024-07-01" && (const_var.crmSetting.is_Edit == true || const_var.isKLinkEnable == true)) ||
							const_var.loginSession == false ||
							const_var.loginSession == true)
							? true
							: false;

					params.isDefault_l_t_r_p = params.b_l_t_r_pR = dataNew.roof_pitch[i].roof_pitch.split("/")[0];
					if (checkType == true) {
						params.b_l_t_r_pR = "3";
					}
					if (params.leanStyle.right == "gable") {
						checkRoofPitch(b_l_t_r_pR_old, "right", dataNew);
					}
					cuBuilding.UpdateRightLean();
				}
			}
		}
		if (const_var.crmSetting.is_Edit == false && const_var.defaultBuildingArr[state.defaultBuilding] != undefined) {
			if (
				const_var.checkforLeanto == true &&
				const_var.defaultBuildingArr[state.defaultBuilding].leanto_data != undefined &&
				Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"]).length > 0
			) {
				let isRoofPitchExsist = dataNew.roof_pitch.find((obj) => obj.roof_pitch == const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].roof_pitch);
				if (isRoofPitchExsist != undefined) {
					params.isDefault_l_t_r_p = params.b_l_t_r_pR = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].roof_pitch.split("/")[0];
					state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].roof_pitch] =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].roof_pitch.split("/")[0];
				}

				cuBuilding.UpdateRightLean();
			} else {
				if (
					const_var.checkforLeanto == true &&
					const_var.defaultBuildingArr[state.defaultBuilding].leanto_data != undefined &&
					Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"]).length == 0 &&
					(const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch != undefined || const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch != null)
				) {
					params.isDefault_l_t_r_p = params.b_l_t_r_pR = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
					state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch] = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
					cuBuilding.UpdateRightLean();
				}
			}
		}

		if (const_var.checkforLeanto == true) {
			const_var.UpdatedPriceData.height_price_changed = true;
			if (params.p_i_o != 0) {
				const_var.UpdatedPriceData.roof_style_price_changed = true;
			}
			const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
			const_var.UpdatedPriceData.bothLeanto = true;
			const_var.UpdatedPriceData.connection_fee_end_changed = true;
			const_var.UpdatedPriceData.connection_fee_side_changed = true;
			const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
			const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
			const_var.UpdatedPriceData.right_wall_price_changed = true;
			if (params.p_j_t == true) {
				const_var.UpdatedPriceData.common_length_changed = true;
			}
		}

		utils.checkColoredScrewsForLeanto("right", const_var.leanGetDataRight);
		makeDimensionUpdateRight(state);
		cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
		const_var.checkforLeanto = false;
	}

	//--- front lean wall
	if (state.params.p_b_c_b_f_l == "Close" && state.params.p_b_c_b_f_b == "Close" && state.params.p_b_c_b_f_f == "Close" && state.params.p_b_c_b_f_r == "Close") {
		const_var.setLeanWallOption.frontLean = "close";
	} else if (state.params.p_b_c_b_f_l == "Open" && state.params.p_b_c_b_f_b == "Open" && state.params.p_b_c_b_f_f == "Open" && state.params.p_b_c_b_f_r == "Open") {
		const_var.setLeanWallOption.frontLean = "open";
	} else {
		const_var.setLeanWallOption.frontLean = "partial";
	}
	//--- right lean wall
	if (state.params.p_b_c_b_r == "Close" && state.params.p_b_c_b_r_b == "Close" && state.params.p_b_c_b_r_f == "Close" && state.params.p_b_c_b_r_r == "Close") {
		const_var.setLeanWallOption.rightLean = "close";
	} else if (state.params.p_b_c_b_r == "Open" && state.params.p_b_c_b_r_b == "Open" && state.params.p_b_c_b_r_f == "Open" && state.params.p_b_c_b_r_r == "Open") {
		const_var.setLeanWallOption.rightLean = "open";
	} else {
		const_var.setLeanWallOption.rightLean = "partial";
	}
	//--- left lean wall
	if (state.params.p_b_c_b_l == "Close" && state.params.p_b_c_b_l_b == "Close" && state.params.p_b_c_b_l_f == "Close" && state.params.p_b_c_b_l_r == "Close") {
		const_var.setLeanWallOption.leftLean = "close";
	} else if (state.params.p_b_c_b_l == "Open" && state.params.p_b_c_b_l_b == "Open" && state.params.p_b_c_b_l_f == "Open" && state.params.p_b_c_b_l_r == "Open") {
		const_var.setLeanWallOption.leftLean = "open";
	} else {
		const_var.setLeanWallOption.leftLean = "partial";
	}
	//--- back lean wall
	if (state.params.p_b_c_b_b_l == "Close" && state.params.p_b_c_b_b_b == "Close" && state.params.p_b_c_b_b_f == "Close" && state.params.p_b_c_b_b_r == "Close") {
		const_var.setLeanWallOption.backLean = "close";
	} else if (state.params.p_b_c_b_b_l == "Open" && state.params.p_b_c_b_b_b == "Open" && state.params.p_b_c_b_b_f == "Open" && state.params.p_b_c_b_b_r == "Open") {
		const_var.setLeanWallOption.backLean = "open";
	} else {
		const_var.setLeanWallOption.backLean = "partial";
	}

	// if (const_var.crmSetting.is_Edit == true) {
	// 	if (const_var.c_f_aCer[params.p_e_i] != undefined && const_var.c_f_aCer[params.p_e_i].distance_on_center != undefined && const_var.c_f_aCer[params.p_e_i].distance_on_center != 5) {
	// 		utils.calculateFourthCenterCostwithExtraBows();
	// 	}
	// }

	const_var.is_loader = false;
	state.is_checked_loader = const_var.is_loader;
	dynamicWallOptions(state, type);
	if (state.params.p_w_c_n == true) {
	}
	cuBuilding.BuildingUpdate(true);
};

export default setPricingDataForLeanto;
